import {useApi} from "@shared/composables/useApi"
import {defineStore} from "pinia"
import {ref} from "vue"

export const useTermsAndConditionsStore = defineStore('TermsAndConditionsStore', () => {
    const {apiGet} = useApi()

    const isTermsAndConditionsModalVisible = ref(false)

    const termsAndConditions = ref('')

    const setTermsAndConditionsModalVisibility = (isVisible) => {
        if (isVisible) {
            fetchTermsAndConditions()
        }
        isTermsAndConditionsModalVisible.value = isVisible
    }

    const fetchTermsAndConditions = async () => {
        try {
            const {data} = await apiGet('api/terms-and-conditions-content')
            termsAndConditions.value = data
        } catch (e) {
            termsAndConditions.value = { error: 'Failed to load terms.' }
        }
    }

    return {
        isTermsAndConditionsModalVisible,
        termsAndConditions,
        fetchTermsAndConditions,
        setTermsAndConditionsModalVisibility
    }
})
